<template>
  <span>
    <b-button v-if="isCreateMode"
              type="button"
              variant="success"
              @click="toggle"
    ><i class="fas fa-plus"></i> Create</b-button>

    <b-button v-else variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-tabs content-class="mt-3">
          <b-tab title="Details" active>
            <b-form-group label="Name" label-for="name-input">
              <b-form-input id="name-input" v-model="currencyForm.name" autocomplete="off" required></b-form-input>
            </b-form-group>
            <b-form-group label="Symbol" label-for="sym-input">
              <b-form-input id="sym-input" v-model="currencyForm.symbol" :readonly="!isCreateMode"  autocomplete="off" required></b-form-input>
            </b-form-group>
            <b-form-group label="Base symbol" label-for="base-sym-input">
              <b-form-input id="base-sym-input" v-model="currencyForm.baseSymbol"  autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Fraction digits" label-for="digits-input">
              <b-form-input id="digits-input" v-model="currencyForm.units" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Number" label-for="number-input">
              <b-form-input id="number-input" v-model="currencyForm.number" autocomplete="off"></b-form-input>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </form>
      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
const MODE_CREATE = 'create';

export default {
  data() {
    return {
      currencies: [],
      currencyForm: {},
      isCreateMode: true,
      modalShow: false,
      currenciesIsLoading: false,
      currenciesTimeout: null
    }
  },
  components: {
  },
  props: [
    'currency',
    'mode',
  ],
  methods: {
    checkFormValidity() {
      return this.$refs.form.checkValidity();
    },
    resetModal() {
      this.currencyForm = {
        id: this.currency.id,
        name: this.currency.name,
        symbol: this.currency.symbol,
        baseSymbol: this.currency.baseSymbol,
        number: this.currency.number,
        units: this.currency.units,
      }
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }

      this
        .$http({
          url: this.isCreateMode ? '/api/v1/softswiss-currencies' : '/api/v1/softswiss-currencies/' + this.currency.symbol,
          data: {
            name: this.currencyForm.name,
            symbol: this.currencyForm.symbol,
            baseSymbol: this.currencyForm.baseSymbol ? this.currencyForm.baseSymbol : null,
            number: this.currencyForm.number,
            units: parseInt(this.currencyForm.units),
          },
          method: this.isCreateMode ? 'POST' : 'PUT'
        })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish')
          }, 500);

          this.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
  },
  computed: {
    title() {
      if (this.isCreateMode) {
        return 'Create currency';
      } else {
        return 'Edit currency';
      }
    },
  },
  watch: {
  },
  mounted() {
    this.isCreateMode = this.mode === MODE_CREATE;
  },
}
</script>
